module.exports = __webpack_public_path__ + "static/media/2.d0d9d3e3.png";